<template>
  <header>
        <div class="logoArea">
            <img alt="school logo" :src="schoolLogoFilePath"  class="logo" v-if="showHeader">
            <!-- <p class="schoolname" v-show="showHeader">{{schoolname}}</p> -->
        </div>

        <div class="navArea" v-if="loggedIn">
            <div class="vertFlex">

                <!-- nowrap: keep the tabs on ONE line and let .navArea (overflow-x:auto) scroll horizontally
                     on narrow widths, instead of wrapping to a second row (per request 2026-08-19). -->
                <div class="horizFlex" style="flex-wrap:nowrap;">
                    <button :class="navButtonClass('openclose')" @click="selectNav('openclose')" v-if="showOpenClose" :disabled="disableTab('Open Close Tab')">
                        Open/Close
                    </button>
                    <button :class="navButtonClass('productgroup')" @click="checkNav('productgroup','Product Group Tab')" :disabled="disableTab('Product Group Tab')" v-if="showProductGroups">
                        Product Groups
                    </button>
                    <button :class="navButtonClass('product')" @click="checkNav('product','Product Tab')" :disabled="disableTab('Product Tab')" v-if="showProducts">
                        Products
                    </button>
                    <button :class="navButtonClass('vendor')" @click="checkNav('vendor','Vendor Tab')" :disabled="disableTab('Vendor Tab')" v-if="showVendors">
                        Vendors
                    </button>
                    <button :class="navButtonClass('transactions')" @click="checkNav('transactions','Transactions Tab')" :disabled="disableTab('Transactions Tab')" v-if="showTransactions">
                        Transactions
                    </button>
                    <button :class="navButtonClass('inventory')" @click="checkNav('inventory','Inventory Tab')" :disabled="disableTab('Inventory Tab')" v-if="showInventory">
                        Inventory
                    </button>
                    <button :class="navButtonClass('library')" @click="checkNav('library','Library Tab')" :disabled="disableTab('Library Tab')" v-if="showLibrary">
                        Equipment 
                    </button>
                    <button :class="navButtonClass('tables')" @click="checkNav('tables','Table Tab')" :disabled="disableTab('Table Tab')" v-if="showTables">
                        Tables 
                    </button>
                    <button :class="navButtonClass('reservations')" @click="checkNav('reservations','Reservations Tab')" :disabled="disableTab('Reservations Tab')" v-if="showReservations">
                        Seating
                    </button>
                    <button :class="navButtonClass('categories')" @click="checkNav('categories','Category Tab')" :disabled="disableTab('Category Tab')" v-if="showCategoryAdmin">
                        Categories
                    </button>
                    <button :class="navButtonClass('filterattributes')" @click="checkNav('filterattributes','Category Tab')" :disabled="disableTab('Category Tab')" v-if="showCategoryAdmin">
                        Filter Attributes
                    </button>
                </div>
                <p v-if="isInventoryBelowTarget && showInvAlert" class="redtext">You have reached a re-order level on at least one product. Go to Inventory/At Reorder Level to view them</p>
                
                <div class="horizFlexCenter" v-if="HeaderOpenCloseMessageString!=null">
                    <p  class="orangetext">{{ HeaderOpenCloseMessageString }}</p>
                    <button class="babybutton" @click="HeaderOpenCloseMessageString=null">OK</button>
                    
                </div >
                <div class="horizFlexCenter" v-if="depositSlipData!=null">
                    <linkbutton ref="depositsliplinkbutton"  v-print="'#depositslipdatadiv'" toplabel="Click to Print the Deposit Slip" class="margin10"/>
                </div>
                <div class="horizFlexCenter" v-if="depositSlipData!=null">
                    
                    <div hidden>
                        <div  class="depositslipclass" id="depositslipdatadiv" v-if="depositSlipData!=null" >
                            <label >{{depositSlipData}}</label>
                        </div>
                    </div>
                    
                    <!-- <a :href="depositSlipUrl" target="_blank" ref="inventoryreportlink">Click to view or print the Deposit Summary </a> -->
                </div>
                
            </div>
            
            
            <!-- <button :class="navButtonClass('wallet')" @click="selectNav('wallet')">Wallets</button> -->
            <!-- <button :class="navButtonClass('explorer')" @click="selectNav('explorer')">Transactions</button>
            
            <button :class="navButtonClass('report')" @click="selectNav('report')">Reports</button>
            <button :class="navButtonClass('admin')" @click="selectNav('admin')">Admin</button> -->
        </div>  
     
        <div class="userArea vertFlex rightjustified" v-if="loggedIn && showHeader">
            <p class="userlabel bold">{{loggedInUser.name}}</p>
            <p class="userlabel" v-if="loggedInUser.isAdmin">ADMIN</p>       
            <linkbutton @click="logout()" toplabel="Logout" />
            <!-- <updatepassword :isAdminChangePassword="false"   :username="username" /> --> 
        </div>
        <securityoverride ref="override"  @overridesuccessful="overrideSuccessful"/>
    </header>
</template>

<script>
import {mapFields} from 'vuex-map-fields'
import linkbutton from './controls/linkbutton.vue'
import securityhelper from '../services/securityhelper.js'
import securityoverride from './actions/securityoverride.vue'
// import updatepassword from './actions/updatepassword.vue'
import datamethods from '../services/datamethods'
import inventoryservice from '../services/inventoryservice.js'
import print from 'vue3-print-nb'
import Linkbutton from './controls/linkbutton.vue'
export default {
    name: "navheader",
    components:{
        linkbutton,
       securityoverride
    },
    mixins:[datamethods,securityhelper,inventoryservice],
    directives:{
        print
    },
    data() {
        return {
            // schoolLogoFilePath:'./../' + window.SCHOOL_LOGO,
            schoolname:window.SCHOOL_NAME,
            savedCurrentNav:null
        };
    },
    computed:{
        ...mapFields([
            'currentNav',
            'loggedIn',
            'loggedInUser',
            'lastRefreshDateTime',
            'username',
            'oldpassword',
            'logoOverride',
            'imageBasePath',
            'showHeader',
            'isInventoryBelowTarget',
            'HeaderOpenCloseMessageString',
            'depositSlipUrl',
            'depositSlipData'

        ]),
        schoolLogoFilePath(){
            
                return './../' + window.SCHOOL_LOGO
            

        },
        showInvAlert(){
            if(window.SHOW_INVENTORY_LEVEL_ALERT==undefined){return false}
            else{return window.SHOW_INVENTORY_LEVEL_ALERT}
        },
        showOpenClose(){
            if(window.SHOW_OPEN_CLOSE==undefined){return true}
            else{return window.SHOW_OPEN_CLOSE}
        },
        // Per-school gates for the core tabs (default true = preserve prior always-on behavior).
        showProductGroups(){
            if(window.SHOW_PRODUCT_GROUPS==undefined){return true}
            else{return window.SHOW_PRODUCT_GROUPS}
        },
        showProducts(){
            if(window.SHOW_PRODUCTS==undefined){return true}
            else{return window.SHOW_PRODUCTS}
        },
        showVendors(){
            if(window.SHOW_VENDORS==undefined){return true}
            else{return window.SHOW_VENDORS}
        },
        showTransactions(){
            if(window.SHOW_TRANSACTIONS==undefined){return true}
            else{return window.SHOW_TRANSACTIONS}
        },
        showInventory(){
            if(window.SHOW_INVENTORY==undefined){return true}
            else{return window.SHOW_INVENTORY}
        },
        useAppSecurity(){
            if(window.USE_APP_SECURITY==undefined){return false}
            else{return window.USE_APP_SECURITY}
        },
        showLibrary(){
            
            if(window.SHOW_LIBRARY==undefined){return false}
            else{return window.SHOW_LIBRARY}
        },
        showTables(){
            if(window.SHOW_TABLES==undefined){return false}
            else{return window.SHOW_TABLES}
        },
        showReservations(){
            if(window.SHOW_RESERVATIONS==undefined){return false}
            else{return window.SHOW_RESERVATIONS}
        },
        showCategoryAdmin(){
            return !!window.ECOM_CATEGORY_ADMIN
        }
    },
    methods:{
        //for new app security
        disableTab(name){
            return this.useAppSecurity && !this.canAccess(name)
        },
        checkNav(name,securityname){
            //check for app security
            if (!this.useAppSecurity){this.selectNav(name); return;}

            this.savedCurrentNav=name //stash this so we can go to it after it works
            if(this.canAccess_allowOverride('POSAdmin',securityname)){
                //console.log('already has access')
                this.selectNav(name)
            }
            
        },
        selectNav(name){
            this.depositSlipData=null
            this.currentNav=name;
            if(window.SHOW_INVENTORY_LEVEL_ALERT){ this.getInventoryBelowTarget(-1)}
            
        },
        overrideSuccessful(){
            //console.log('override!!! call success function')
            this.selectNav(this.savedCurrentNav)
        },
        navButtonClass(name){
            if(this.currentNav==name){
                return "selectedNav"
            }else{
                return "unselectedNav"
            }
        },
        logout(){
            this.loggedIn=false;
            this.$emit('logout')
        },
        /* async getImageBasePath(){
            //call api
            var response = await this.callAPI_Image(null,'imagepath')
            //handle response
            if(response.Successful){
                this.imageBasePath = response.StringResponse
            }else{
                this.responseMessage = response.Message
            }
        }, */
    },
    mounted(){
        //this.getImageBasePath();
    }
}
</script>

<style>
header{
    grid-area:header;
    padding:10px 20px 10px 10px;
    display:grid;
    grid-template-columns:1fr 4fr 1fr;
    grid-template-rows:auto;
    grid-template-areas: 
        "logo nav user";
    font-size:medium;
    background-color:var(--header-color);
}
.logo{
    max-width: 100%;
    max-height:75px;
}
.navArea{
    padding:0px;
    margin:0px;
    /* Scroll the tab row horizontally when it's wider than the nav column (e.g. many tabs on a
       narrow window) instead of clipping tabs off the right edge. No scrollbar when they fit. */
    overflow-x:auto;
    overflow-y:hidden;
}
.selectedNav{
    color:var(--light-text-color);
    background-color:var(--button-color);
    border: 4px solid var(--highlight-button-color);
    border-radius:2px;
    width:105px;
    height:50px;
    padding:0px;
    font-size: medium;
     margin:5px;

}
.unselectedNav{
    color:var(--light-text-color);
    background-color:var(--button-color);
    border: none;
    border-radius:2px;
    width:105px;
    height:50px;
    padding:0px;
    font-size: medium;
    margin:5px;
}
/* Overflow protection for the fixed-width nav tabs — long labels / translations wrap and
   clip inside the button instead of spilling over neighbours (SER-343). */
.selectedNav, .unselectedNav{
    overflow:hidden;
    word-break:break-word;
    line-height:1.05;
    padding:2px;
    box-sizing:border-box;
}
.schoolname{
    font-size:large;
    text-align: center;
    margin:0px 0px 0px 20px;
}
.userlabel{
   
    margin:0px 0px 10px 0px;
    
}
.userArea{
  grid-area:user;
}
.modeImage{
    height:25px;
    margin:5px;
}
.buttoninside{
  display:flex;
  flex-direction: column;
  margin:0px;
    padding:0px;
}
.buttonlabel{
    margin:0px;
}
.babybutton{
    height:20px;
    margin:15px;
}
.depositslipclass{
margin-top:40px;
  white-space: pre-wrap;
  
} 
.noheight{
    height: 0px;
}
</style>